import {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";

import {useConfigModule} from "base/ui/module/provider";
import {useErrors} from "base/error/provider";
import {LocationProvider} from "snimf/location/provider";

import {PermitExtensionService} from "permitextension/service";

import {PageLayout} from "base/ui/main";
import {PermitExtensionSubPageMenu} from "permitextension/menu";

const ViewPermitExtensionPage = () => {
    const {id} = useParams();

    const [element, setElement] = useState(null);
    const location = useLocation();

    const {handleErrors} = useErrors();
    const {setModuleBasePath, isLoading, setIsLoading} = useConfigModule();

    useEffect(() => {
        setIsLoading(true);
        setElement(null);
        setModuleBasePath(`/extensions/list/${id}`);

        PermitExtensionService.get(id)
            .then(data => {
                setElement(data);
            })
            .catch(error => {
                handleErrors(error);
            })
            .finally(() => setIsLoading(false));
    }, [id, location.state?.lastRefreshDate]);

    return (
        <LocationProvider>
            <PageLayout
                menu={<PermitExtensionSubPageMenu extension={element} />}
                context={[element]}
                isLoading={isLoading}
                subPage
            />
        </LocationProvider>
    );
};

export default ViewPermitExtensionPage;
